<div class="dialog-viewer">
    <div class="row mb-2">
        <h2 mat-dialog-title>Booking Details - {{booking.confirmationNumber}}</h2>
    </div>

    <mat-dialog-content>
        <div class="container-fluid">
            <div class="row mb-3">
                <div class="col-6">
                    <strong>Customer:</strong> {{booking.customerName}}
                </div>
                <div class="col-6">
                    <strong>Status:</strong> {{BookingStatus[booking.status]}}
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-6">
                    <strong>Email:</strong> {{booking.email}}
                </div>
                <div class="col-6">
                    <strong>Phone:</strong> {{booking.phoneNumber}}
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-6">
                    <strong>Start Time:</strong> {{formatInUserTimezone(booking.startTime, 'MM/DD/YYYY h:mm a')}}
                </div>
                <div class="col-6">
                    <strong>End Time:</strong> {{formatInUserTimezone(booking.endTime, 'MM/DD/YYYY h:mm a')}}
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-6">
                    <strong>Duration:</strong> {{calculateDuration()}} hour(s)
                </div>
                <div class="col-6">
                    <strong>Participants:</strong> {{booking.participants}}
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-6">
                    <strong>Total Price:</strong> ${{booking.totalPrice}}
                </div>
                <div class="col-6">
                    <strong>Payment Status:</strong>
                    <span [class.text-success]="booking.hasPaid" [class.text-danger]="!booking.hasPaid">
                        {{booking.hasPaid ? 'Paid' : 'Unpaid'}}
                    </span>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-6">
                    <strong>Created Date:</strong> {{booking.createdDate | date:'MM/dd/yyyy h:mm a'}}
                </div>
                <div class="col-6">
                    <strong>Last Edited:</strong> {{booking.lastEditedDate | date:'MM/dd/yyyy h:mm a'}}
                </div>
            </div>

            <div class="row mb-3" *ngIf="booking.refundAmount">
                <div class="col-12">
                    <strong>Refund Amount:</strong>
                    <span class="text-danger"> ${{booking.refundAmount}}</span>
                </div>
            </div>

            <div class="row mb-3" *ngIf="booking.addons?.length > 0">
                <div class="col-12">
                    <strong>Addons:</strong>
                    <mat-list class="addon-list">
                        <mat-list-item *ngFor="let addon of booking.addons">
                            <div class="d-flex justify-content-between w-100">
                                <span>{{addon.name}}</span>
                                <span class="addon-price">${{addon.price}}</span>
                            </div>
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button (click)="dialogRef.close()">Close</button>
    </mat-dialog-actions>
</div>